import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ad43e8e&scoped=true&"
import script from "./taskAfterSale.ts?vue&type=script&lang=ts&"
export * from "./taskAfterSale.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=5ad43e8e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad43e8e",
  null
  
)

export default component.exports